import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { deleteUser, fetchUserList, deactivateUser,activateUser } from "../actions/user";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { statusRender } from "../utils/cellRenderTable";

const UserList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { userList } = useSelector((state) => state.userReducer);

  //breadcrumb
  const translateModule = "user";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchUserList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (
      !params.data ||
      !params.data.id ||
      !params.data.firstName ||
      !params.data.lastName
    )
      return null;
    return (
        <ButtonColumn
          editLink={`/user-edit/${params.data.id}`}
          deleteItemId={params.data.id}
          deleteItemTitle={`${params.data.firstName} ${params.data.lastName}`}
          activeItemTitle={`${params.data.firstName} ${params.data.lastName}`}
          deactiveItemTitle={`${params.data.firstName} ${params.data.lastName}`}
          status={params.data.active ? "ACTIVE" : "INACTIVE"}
          submitActionModal={handleSubmitModal}
        />
    );
  };

  const handleSubmitModal = (pageId, typeAction) => {
    if (typeAction === "delete") {
      dispatch(deleteUser(pageId));
    } else if (typeAction === "deactive") {
      dispatch(deactivateUser(pageId));
    } else if (typeAction === "active") {
      dispatch(activateUser(pageId)); 
    }
  };

  const columnDefs = [
    {
      headerName: "Ime",
      field: "firstName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Prezime",
      field: "lastName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Uloga",
      field: "type",
      filter: "agSetColumnFilter",
      valueGetter: (params) => {
        if (!params.data || !params.data.type) return null;
        switch (params.data.type) {
          case "CHANNEL_OWNER":
            return "Vlasnik kanala";
          case "BASIC_USER":
            return "Korisnik";
          default:
            return "";
        }
      },
    },
    {
      headerName: "Email adresa",
      field: "email",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: "Newsletter",
      field: "newsletter",
      filter: "agSetColumnFilter",
    },
    {
      headerName: "Aktivan",
      field: "active",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      maxWidth: 180,
      valueGetter: (params) => {
        if (params.data?.active === true) return "Aktivan";
        if (params.data?.active === false) return "Neaktivan";
        return "";
      },
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 135,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchUserList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={userList}
        columnDefs={columnDefs}
        buttonLink={`/user-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="user-list"
      />
    </Fragment>
  );
};

export default UserList;
